import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the Token Context
const TokenContext = createContext(null);

// Provider Component
export const TokenProvider = ({ children }) => {
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        try {
            const userToken = JSON.parse(tokenString);
            return userToken?.token || null;
        } catch {
            return null;
        }
    };

    const [token, setToken] = useState(getToken);

    const saveToken = (userToken) => {
        if (userToken) {
            localStorage.setItem('token', JSON.stringify(userToken));
            setToken(userToken.token);
        } else {
            localStorage.removeItem('token');
            setToken(null);
        }
    };

  

    return (
        <TokenContext.Provider value={{ token, setToken: saveToken }}>
            {children}
        </TokenContext.Provider>
    );
};

// Hook to use the Token Context
export const useToken = () => {
    const context = useContext(TokenContext);
    if (!context) {
        throw new Error('useToken must be used within a TokenProvider');
    }
    return context;
};
